import { TCheckedType, TProjectConfigurationGeneralItem } from 'pages/common/types';
import { getIsCheckedProducts } from 'common/helpers/get-is-checked-products.helper';
import { ZERO_PRICE } from '../consts/prices';
import { TSavedProjectsComplimentaryGroup } from '../types';

export const getComplementaryProductsTotalPrice = ({
  complementaryProducts,
  checkedProducts,
  complimentaryGroups,
}: {
  complementaryProducts: TProjectConfigurationGeneralItem[];
  checkedProducts: TCheckedType;
  complimentaryGroups: TSavedProjectsComplimentaryGroup[];
}) => {
  const complementaryProductsPrice = complementaryProducts.reduce((total, product) => {
    const isProductChecked = getIsCheckedProducts({ checkedProducts, productId: product.code });
    const price = isProductChecked ? product.price : ZERO_PRICE;

    return total + price * product.quantity;
  }, ZERO_PRICE);
  const complementaryGroupsPrice = complimentaryGroups.reduce((total, group) => {
    const selectedProduct = group.products.find(product => product.code === group.selectedProductId);
    if (selectedProduct) {
      const isProductChecked = getIsCheckedProducts({ checkedProducts, productId: selectedProduct.code });
      const price = isProductChecked ? selectedProduct.price : ZERO_PRICE;

      return total + price * selectedProduct.quantity;
    }

    return total;
  }, ZERO_PRICE);

  return complementaryProductsPrice + complementaryGroupsPrice;
};
